import React from "react";

const SelectScreeningStatus = ({ label = "Review Status", className = "" }) => {
  return (
    <div className="select-screening-status">
      <label className="text-gray fw-medium p-1 mb-1">
        {label}
      </label>
      <select className={`form-select form-select-lg ${className}`}>
        <option>New Submission</option>
        <option>Needs Review</option>
        <option>Complete</option>
        <option>Pends from Applicant</option>
        <option>Verification in Progress</option>
        <option>Under Analyst Review</option>
      </select>
    </div>
  );
};

SelectScreeningStatus.propTypes = {};

export default SelectScreeningStatus;
